"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillLinesParsedRequest = exports.transformBillLinesParsedResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("./Money");
function transformBillLinesParsedResponse(line) {
    return {
        categoryId: line.categoryid,
        category: line.category,
        listIndex: line.list_index,
        description: line.description,
        quantity: line.quantity,
        unitCost: line.unit_cost && (0, Money_1.transformMoneyParsedResponse)(line.unit_cost),
        amount: line.amount && (0, Money_1.transformMoneyParsedResponse)(line.amount),
        totalAmount: line.total_amount && (0, Money_1.transformMoneyParsedResponse)(line.total_amount),
        taxName1: line.tax_name1,
        taxName2: line.tax_name2,
        taxPercent1: line.tax_percent1,
        taxPercent2: line.tax_percent2,
        taxAuthorityId1: line.tax_authorityid1,
        taxAuthorityId2: line.tax_authorityid2,
        taxAmount1: line.tax_amount1 && (0, Money_1.transformMoneyParsedResponse)(line.tax_amount1),
        taxAmount2: line.tax_amount2 && (0, Money_1.transformMoneyParsedResponse)(line.tax_amount2),
    };
}
exports.transformBillLinesParsedResponse = transformBillLinesParsedResponse;
function transformBillLinesParsedRequest(line) {
    return {
        categoryid: line.categoryId,
        description: line.description,
        quantity: line.quantity,
        unit_cost: line.unitCost && (0, Money_1.transformMoneyParsedRequest)(line.unitCost),
        tax_name1: line.taxName1,
        tax_name2: line.taxName2,
        tax_percent1: line.taxPercent1,
        tax_percent2: line.taxPercent2,
        tax_authorityid1: line.taxAuthorityId1,
        tax_authorityid2: line.taxAuthorityId2,
    };
}
exports.transformBillLinesParsedRequest = transformBillLinesParsedRequest;
//# sourceMappingURL=BillLines.js.map